import { Outlet } from 'react-router-dom'
import React from 'react'

const Home = () => {
  return (
    <Outlet/>
  )
}

export default Home